<template>
  <el-form
    :model="accessGrokForm"
    :rules="accessGrokRules"
    ref="accessGrokForm"
    label-width="160px"
    :inline-message="true"
    class="access-grok-form rule-form"
  >
    <el-form-item class="form-tip-top" prop="logExample" label="日志样例：">
      <el-input
        v-model="accessGrokForm.logExample"
        type="textarea"
        :autosize="{ minRows: 4 }"
        placeholder="请输入日志样例"
        :disabled="formType === 'SHOW'"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <p class="form-tip">
        请贴入需要解析的日志样例，注意粘贴时要保持原日志样例的格式。例如：11.1.111.1 GET /index.html
        11111 1.111
      </p>
    </el-form-item>
    <div class="access-grok-form-pattern">
      <el-form-item class="form-tip-top" prop="pattern" label="提取表达式：">
        <el-input
          v-model="accessGrokForm.pattern"
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入提取表达式"
          :disabled="formType === 'SHOW'"
        >
        </el-input>
        <el-button
          v-if="formType !== 'SHOW'"
          class="pattern-btn"
          type="primary"
          @click="onParsePattern"
          >测试</el-button
        >
      </el-form-item>
      <el-form-item v-if="!!errorTip">
        <p class="error-tip">{{ errorTip }}</p>
      </el-form-item>
      <el-form-item>
        <p class="form-tip">
          请输入Grok语法的提取表达式，例如：%{IP:client} %{WORD:method} %{URIPATHPARAM:request}
          %{NUMBER:bytes} %{NUMBER:duration}。具体说明请参考
          <router-link target="_blank" :to="{ path: '/grok' }">
            <span class="form-tip-link">帮助文档</span>
          </router-link>
        </p>
      </el-form-item>
      <div
        class="access-grok-form-flex"
        v-for="(result, index) in accessGrokForm.results"
        :key="index"
      >
        <el-form-item
          :prop="`results[${index}].key`"
          class="form-tip-top access-grok-form-flex-key"
          :rules="accessGrokRules.results"
        >
          <span slot="label" v-if="index === 0"> 提取结果：</span>
          <el-input
            :title="result.key"
            v-model="result.key"
            disabled
            style="margin-right:10px;"
          ></el-input>
        </el-form-item>
        <el-form-item class="access-grok-form-flex-int" label-width="0">
          <el-input :title="result.value" v-model="result.value" disabled></el-input>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Validator from '../../../../utils/Validator';
import { reqFetchParsePattern } from '../../../../api/log';

export default {
  name: 'AccessGrokRuleCreator',

  props: {
    accessConfigForm: {
      type: Object
    },
    formType: {
      type: String
    }
  },

  data() {
    const validatorRequired = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.required()).validate();
    };

    const validatorStandardStr = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator
        .register(validator.isNoSpace())
        .register(validator.isStandardStr())
        .validate();
    };

    const validatorLength = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.lenRange(50)).validate();
    };

    return {
      errorTip: '',
      accessGrokForm: {
        logExample: '',
        pattern: '',
        results: [
          {
            key: '',
            value: ''
          }
        ]
      },
      accessGrokRules: {
        logExample: [
          { required: true, message: '请输入日志样例', trigger: 'blur' },
          { validator: validatorRequired, message: '请输入日志样例', trigger: 'blur' }
        ],
        pattern: [
          { required: true, message: '请输入提取表达式', trigger: 'blur' },
          { validator: validatorRequired, message: '请输入提取表达式', trigger: 'blur' }
        ],
        results: [
          {
            required: true,
            message: 'key 不能为空',
            trigger: 'change'
          },
          { validator: validatorRequired, message: 'key 不能为空', trigger: ['blur', 'change'] },
          { validator: validatorStandardStr, trigger: 'blur' },
          { validator: validatorLength, trigger: 'blur' }
        ]
      }
    };
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      this.accessGrokForm = {
        logExample: this.accessConfigForm.logExample,
        pattern: this.accessConfigForm.pattern,
        results: this.accessConfigForm.results
      };
    },
    /**
     * grok 解析
     */
    async onParsePattern() {
      if (!this.accessGrokForm.logExample || !this.accessGrokForm.pattern) {
        return;
      }

      this.formLoading = true;
      const { data } = await reqFetchParsePattern({
        logExample: this.accessGrokForm.logExample,
        pattern: this.accessGrokForm.pattern
      });

      if (Object.keys(data).length > 0) {
        this.accessGrokForm.results = Object.keys(data).map(item => ({
          key: item,
          value: data[item]
        }));

        this.errorTip = '';
      } else {
        this.accessGrokForm.results = [
          {
            key: '',
            value: ''
          }
        ];

        this.errorTip = '提取结果解析失败，请检查日志样例和提取表达式';
      }
    },
    onSaveData() {
      return this.accessGrokForm;
    },
    /**
     * 提交验证
     */
    onValidate() {
      return this.$refs.accessGrokForm.validate();
    }
  }
};
</script>

<style lang="scss" scoped>
.access-grok-form {
  &-pattern {
    position: relative;

    .pattern-btn {
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(110%);
    }
  }

  &-flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;

    &-int {
      width: 40%;
    }

    &-key {
      width: 60%;
      margin-right: 10px;
    }
  }
}
</style>
